import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { Layout } from "./components/layout/Layout";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Pages
import Home from "./pages/Home";
import Werkwijze from "./pages/Werkwijze";
import OverMij from "./pages/OverMij";
import Contact from "./pages/Contact";
import Intake from "./pages/Intake";
import SeoPakketten from "./pages/SeoPakketten";
import Diensten from "./pages/Diensten";
import ServiceDetail from "./pages/ServiceDetail";
import SeoConsultant from "./pages/SeoConsultant";
import SeoConsultantPillar from "./pages/SeoConsultantPillar";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Admin from "./pages/Admin";
import Disclaimer from "./pages/Disclaimer";
import Privacyverklaring from "./pages/Privacyverklaring";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Route - No Layout */}
          <Route path="/admin/*" element={<Admin />} />
          
          {/* Dutch Routes */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/werkwijze" element={<Layout><Werkwijze /></Layout>} />
          <Route path="/over-mij" element={<Layout><OverMij /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/intake" element={<Layout><Intake /></Layout>} />
          
          {/* Packages */}
          <Route path="/seo-pakketten" element={<Layout><SeoPakketten /></Layout>} />
          
          {/* Services */}
          <Route path="/diensten" element={<Layout><Diensten /></Layout>} />
          <Route path="/diensten/:serviceId" element={<Layout><ServiceDetail /></Layout>} />
          
          {/* SEO Consultant - Pillar + Locations and Sectors */}
          <Route path="/seo-consultant" element={<Layout><SeoConsultantPillar /></Layout>} />
          <Route path="/seo-consultant/:slug" element={<Layout><SeoConsultant /></Layout>} />
          <Route path="/freelance-seo-consultant/:slug" element={<Layout><SeoConsultant /></Layout>} />
          
          {/* Blog */}
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
          
          {/* Legal */}
          <Route path="/disclaimer" element={<Layout><Disclaimer /></Layout>} />
          <Route path="/privacyverklaring" element={<Layout><Privacyverklaring /></Layout>} />
          
          {/* English Routes */}
          <Route path="/en" element={<Layout><Home /></Layout>} />
          <Route path="/en/how-i-work" element={<Layout><Werkwijze /></Layout>} />
          <Route path="/en/about" element={<Layout><OverMij /></Layout>} />
          <Route path="/en/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/en/intake" element={<Layout><Intake /></Layout>} />
          
          {/* English Packages */}
          <Route path="/en/seo-packages" element={<Layout><SeoPakketten /></Layout>} />
          
          {/* English Services */}
          <Route path="/en/services" element={<Layout><Diensten /></Layout>} />
          <Route path="/en/services/:serviceId" element={<Layout><ServiceDetail /></Layout>} />
          
          {/* English SEO Consultant - Pillar only, no sector subpages */}
          <Route path="/en/seo-consultant" element={<Layout><SeoConsultantPillar /></Layout>} />
          
          {/* English Blog */}
          <Route path="/en/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/en/blog/:slug" element={<Layout><BlogPost /></Layout>} />
          
          {/* English Legal */}
          <Route path="/en/disclaimer" element={<Layout><Disclaimer /></Layout>} />
          <Route path="/en/privacy-policy" element={<Layout><Privacyverklaring /></Layout>} />
          
          {/* 404 Catch-all */}
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
